import { Unit, UnitPrefix } from "uom";
import * as UnitDivide from "../unit-divide";
import { Newton } from "./force";
import { SquareMeter } from "./area";
/**
 * The derived unit for pressure, stress ( <code>Pa</code> ).
 * One pascal is equal to one newton per square meter.
 * It is named after the French philosopher and mathematician Blaise Pascal (1623-1662).
 */
export var Pascal = UnitDivide.forceByArea("Pascal", Newton, SquareMeter);
// Pressure
export var KiloPascal = UnitPrefix.Kilo("KiloPascal", Pascal);
export var HectoPascal = UnitPrefix.Hecto("HectoPascal", Pascal);
export var NewtonPerSquareMeter = UnitDivide.forceByArea("NewtonPerSquareMeter", Newton, SquareMeter);
export var PoundForcePerSquareInch = Unit.divideNumber("PoundForcePerSquareInch", 1290320000.0, Unit.timesNumber("", 8896443230521.0, Pascal));
export var PoundForcePerSquareFoot = Unit.timesNumber("PoundForcePerSquareFoot", 144.0, PoundForcePerSquareInch);
export var DeciPascal = UnitPrefix.Deci("DeciPascal", Pascal);
// http://www.wolframalpha.com/input/?i=psi and select 'Show exact conversions'
export var InchOfMercury = Unit.divideNumber("InchOfMercury", 152.0, Unit.timesNumber("", 514731.0, Pascal));
// http://www.wolframalpha.com/input/?i=inHg and select 'Show exact conversions'
export var InchOfWaterColumn = Unit.timesNumber("InchOfWaterColumn", 249.0889, Pascal);
// http://www.wolframalpha.com/input/?i=inWC
export var FeetOfWaterColumn = Unit.timesNumber("FeetOfWaterColumn", 2989.067, Pascal);
export var Bar = Unit.timesNumber("Bar", 100000.0, Pascal);
export var MilliBar = UnitPrefix.Milli("MilliBar", Bar);
//# sourceMappingURL=pressure.js.map